export default "__VITE_ASSET__256f0050__"